import { jsx as _jsx } from "react/jsx-runtime";
import { SSIToastContainerContainerStyled as Container } from '../../../../styles';
const SSIToastContainer = (props) => {
    const { position = 'top-right', autoHide = true, visibilityTimeMs = 6000, pauseOnHover = true } = props;
    return (_jsx(Container, { position: position, autoClose: !autoHide ? autoHide : visibilityTimeMs, hideProgressBar: true, closeButton: false, pauseOnHover: pauseOnHover }));
};
export default SSIToastContainer;
